export { default as EvidenceModal } from './EvidenceModal';
export {
    EvidenceStateProvider,
    useOpenEvidenceModal,
    useCloseEvidenceModal,
    useEvidenceModalData,
    useUpdateSelectedSourceFile,
    useUpdateSelectedEvidence,
    useEvidenceState,
} from './EvidenceState';
export type { EvidenceField } from './types';
